<template>
  <div class="row">
    <yukyu-menu></yukyu-menu>
    <div class="col-md-10 pt-3">
        <div class="form-group">
            <span style="font-size: 1.3em;vertical-align: middle;">{{startYearMonth | yearMonth}} 〜 </span>
            <select class="search-select custom-select" name="endYear" v-model="selectedEndYear" @change="getYukyuControlBook">
                <option v-for="year in yearList" :value="year" :key="year">
                    {{year}}
                </option>
            </select>
            <span>年</span>
            <select class="search-select custom-select" name="endMonth" v-model="selectedEndMonth" @change="getYukyuControlBook">
                <option v-for="month in monthList" :value="month" :key="month">
                    {{month}}
                </option>
            </select>
            <span>月</span>

            <a :href="`/api/leave_request/download/excel?endYear=${selectedEndYear}&endMonth=${selectedEndMonth}`">
                <button type="button" class="btn btn-info" style="border-radius: 50px;">
                    <i class="fas fa-cloud-download-alt fa-1x" aria-hidden="true"></i>ダウンロード
                </button>
            </a>
        </div>
        <div style="margin-bottom: 20px;border: 1px solid #EBEEF5;padding: 5px;">
          表示オプション
          <div>
            <el-checkbox size="mini" v-model="nextPaidDay" class="text-mini">次回有給付与日</el-checkbox>
            <el-checkbox size="mini" v-model="nextPaidCount" class="text-mini">次回有給付与日数</el-checkbox>
          </div>
        </div>
        <div class="sub-title">
            有給消化率（平均）: <span>{{ yukyuGetRateAverage }}%</span>
        </div>
        <table class="table table-bordered table-responsive table-sm">
            <thead class="thead-light">
                <tr>
                    <th>氏名</th>
                    <th>入社日</th>
                    <th>有給発生</th>
                    <th>最終有給付与日</th>
                    <th>満有休日数</th>
                    <th>最終有給付与日数</th>
                    <th>前年度繰越日数</th>
                    <th>前年度繰越日数（残）</th>
                    <th>消化数</th>
                    <th>残日数</th>
                    <th>消化率</th>
                    <th v-if="nextPaidDay">次回有給付与日</th>
                    <th v-if="nextPaidCount">次回有給付与日数</th>                    
                    <th v-for="ym in yearMonthList" :key="ym"><span>{{ ym }}</span></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="result in controlBookList" :key="result.userId">
                    <td class="noflap">{{result.userName}}</td>
                    <td class="noflap">{{result.hireDate | date }}</td>
                    <td class="noflap">{{result.yukyuStartDate | date }}</td>
                    <td class="noflap">{{result.lastPaidDate | date}}</td>
                    <td>{{result.paidCount}}</td>
                    <td class="noflap">{{result.thisPaidCount}}</td>
                    <td class="noflap">{{result.prevRemainingDaysBase}}</td>
                    <td class="noflap">{{result.prevRemainingDays}}</td>
                    <td>{{result.getCount}}</td>
                    <td>{{result.remainingDays}}</td>
                    <td>{{result.getRate}}%</td>
                    <td class="noflap" v-if="nextPaidDay">{{result.nextPaidDate | date}}</td>
                    <td class="noflap" v-if="nextPaidCount">{{result.nextPaidCount}}</td>
                    <td v-for="ym in yearMonthList" :key="ym" :class="checkBetween(result.yukyuStartDate, `${ym}/01`)">
                        <tr style="height: 15px;">
                          <span v-for="(current, index) in result.yukyuCountList" :key="index">
                              {{ ym == current.year + '/' + twoDigit(current.month) ? current.count : ''}}
                          </span>
                        </tr>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<style scoped>
hr {
  margin: 0;
}
.noflap{
 white-space: nowrap;
}
.l_hilight {
  background: antiquewhite;
}
.hilight {
  background: azure;
}
</style>

<script>
import moment from 'moment'
import LeaveRequestAPI from '../../../api/leave-request-api'
import YukyuMenu from './YukyuMenu.vue'

export default {
  name: "yukyu-management",
  components: {
    YukyuMenu,
  },
  data() {
    return {
      selectedEndYear: moment().year(),
      selectedEndMonth: moment().month() + 1,
      yearList: Array.from(new Array(11)).map((v,i)=> moment().year() -10 + i + 1),
      monthList: Array.from(new Array(12)).map((v,i)=> i + 1),
      controlBookList: [],
      yukyuGetRateAverage: 0,
      // 表示・非表示フラグ
      nextPaidDay: localStorage.getItem('adminDispNextPaidDay') == 'true' ? true : false,
      nextPaidCount: localStorage.getItem('adminDispNextPaidCount') == 'true' ? true : false,
    }
  },
  watch: {
    'nextPaidDay': function(val) {
      localStorage.setItem('adminDispNextPaidDay', val)
    },
    'nextPaidCount': function(val) {
      localStorage.setItem('adminDispNextPaidCount', val)
    },
  },
  mounted () {
    this.getYukyuControlBook()
  },
  methods: {
    // 有給一覧取得
    async getYukyuControlBook () {
      this.$root.$refs.loading.$data.show = true
      let params = {}
      params['endYear'] = this.selectedEndYear
      params['endMonth'] = this.selectedEndMonth
      const res = await LeaveRequestAPI.getYukyuControlBook(params)
      this.controlBookList = res.controlBookList
      this.yukyuGetRateAverage = res.yukyuGetRateAverage
      this.$nextTick(() => {
          this.$root.$refs.loading.$data.show = false
      })
    },
    addMonth (i) {
       return moment([this.selectedEndYear, this.selectedEndMonth -1]).add(-2, 'year').add(i, 'month').format("YYYY/MM")
    },
    twoDigit (data) {
    　  // 2桁0埋め
        return ("0" + data).slice(-2)
    },
    checkBetween (yukyuStartDate, targetMonth) {
        let date = moment(yukyuStartDate).year(moment().year()).date(1)
        if(date.isAfter(moment())){
          date = moment(date).add('year', -1).format("YYYY/MM/DD")
        } else {
          date = moment(date).format("YYYY/MM/DD")
        }
        const l_start = moment(date).add('year', -1).format("YYYY/MM/DD")
        const l_end = moment(date).add('days', -1).format("YYYY/MM/DD")
        const start = moment(date).format("YYYY/MM/DD")
        const end = moment(date).add('year', 1).add('days', -1).format("YYYY/MM/DD")
        if (moment(targetMonth, 'YYYY/MM/DD').isBetween(l_start, l_end, null, '[]')) {
          return 'l_hilight'
        } else if (moment(targetMonth, 'YYYY/MM/DD').isBetween(start, end, null, '[]')) {
          return 'hilight'
        }
    },
  },
  computed: {
      startYearMonth () {
        return moment([this.selectedEndYear, this.selectedEndMonth -1]).add(-2, 'year')
      },
      yearMonthList () {
        return Array.from(new Array(25)).map((v,i)=> this.addMonth(i))
      }
  },
  filters: {
      yearMonth(data) {
          return data.format("YYYY年MM月")
      },
      yearMonthSlash(data) {
          return data.format("YYYY/MM")
      },
      date(data) {
          return data ? moment(data).format("YYYY/MM/DD") : ''
      },
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/yukyu/YukyuControlBook.vue